<script lang="ts">
  import type { BlocksDynamicZone } from 'query-strapi-v4';
  import { getDefaultDevProps, type DevProps } from './dev';
  import CtaInContent from './cta/InContent.svelte';
  import Image from './blocks/Image.svelte';
  import Video from './blocks/Video.svelte';
  import Lookup from './blocks/Lookup.svelte';
  import Editor from './blocks/Editor.svelte';
  import { v4 as uuidv4 } from 'uuid';

  type Blocks = BlocksDynamicZone[];
  // type Blocks = GuideBlocksDynamicZone | ArticleBlocksDynamicZone;
  export let blocks: Blocks;
  export let dev: DevProps = getDefaultDevProps();
</script>

{#each blocks as block, i (uuidv4())}
  <!-- issue with generated types ignoring the __component field. Overriding for now -->
  {#if block.__component === 'blocks.editor'}
    <Editor {block} />
  {/if}
  {#if block.__component === 'blocks.cta'}
    <CtaInContent {block} on:analytics-event blocksLength={blocks.length} blockIndex={i} />
  {/if}
  {#if block.__component === 'blocks.image'}
    <Image {block} />
  {/if}
  {#if block.__component === 'blocks.video'}
    <Video {block} on:analytics-event />
  {/if}
  {#if block.__component === 'blocks.lookup'}
    <!-- {JSON.stringify(dev)} -->
    <Lookup {block} on:analytics-event {dev} />
  {/if}
{/each}
